
import { computed, defineComponent, PropType } from "vue";
import { settingsService } from "@services/settings.service";

export default defineComponent({
  props: {
    prices: {
      type: Object as PropType<Indexable<Products.Price>>,
      required: true,
    },
    placeholder: {
      type: String as PropType<string>,
      default: "-",
    },
  },
  setup(props) {
    const price = computed(() => props.prices.bid || props.prices.nav);
    const priceFormatted = computed(() =>
      new Intl.NumberFormat(settingsService.options.locale, {
        style: "currency",
        currency: price.value.currency_iso,
      }).format(price.value.value)
    );

    return {
      price,
      priceFormatted,
    };
  },
});
